<template>
    <transition
            mode="out-in"
            name = "modal"
            @enter= "enter"
            @before-leave= "leave">
        <div
                class  = "modal-mask"
                @click = "close">
            <div
                    class = "modal-wrapper">
                <div
                        @click.stop
                        class  = "modal-content animated"
                        :class = "animation">
                    <div
                            class="modal-header">
                        <slot
                                name="modal-header">
                            <button
                                    type         = "button"
                                    class        = "close"
                                    data-dismiss = "modal"
                                    aria-label   = "Close"
                                    @click       = "close">
								<span
                                        aria-hidden="true">
									&times;
								</span>
                            </button>
                            <h4
                                    class="modal-title">
                                {{title}}
                            </h4>
                        </slot>
                    </div>

                    <div
                            class = "modal-body">
                        <slot
                                name = "modal-body">
                            default body
                        </slot>
                    </div>

                    <div
                            class = "modal-footer">
                        <slot
                                name = "modal-footer">
                            <button
                                    class  = "modal-default-button"
                                    @click = "close">
                                OK
                            </button>
                        </slot>
                    </div>
                </div><!-- Modal-container end -->
            </div><!-- Modal-wrapper end -->
        </div><!-- Modal-mask end -->
    </transition>
</template>



<script>
    export default {
        data: function(){
            return {
                animate   : true,
                animation : '',
            }
        },
        props: [
            'title',
            'intro',
            'outro'
        ],
        computed:{
            animation_in: function(){
                if( this.intro === undefined )
                    return 'default';
                if( this.intro === 'none' )
                    return '';
                return this.intro;
            },
            animation_out: function(){
                if( this.outro === undefined )
                    return 'default';
                if( this.outro === 'none' )
                    return '';
                return this.outro;
            }
        },
        created: function () {
            document.addEventListener("keydown", (e) => {
                if (e.keyCode == 27)
                    this.close();
            });
        },
        methods: {
            close: function() {
                this.$emit('close');
            },
            enter: function(){
                this.animation = this.animation_in;
            },
            leave: function(){
                this.animation = this.animation_out;
            }
        }
    }
</script>


<!-- my-component.vue -->
<style lang="scss">
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: auto;
        background-color: rgba(0, 0, 0, .5);
        transition: opacity 0.5s ease;
    }



    .modal-wrapper {
        vertical-align: middle;
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 100%;
    }
    .modal-mask.xl .modal-content{
        max-width: 1200px;
        .modal-body{
            margin: 0;
        }
    }
    .modal-content {
        max-width: 700px;
        width: 90%;
        margin: 0px auto;
        background-color: #fff;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all 0.5s ease;
        font-family: Helvetica, Arial, sans-serif;

        strong{
            font-weight: bold;
        }
    }
    .modal-header{
        position: relative;
        h3 {
            margin-top: 0;
            color: #42b983;
        }
        i.close{
            position: absolute;
            right: 30px;
            top: 50%;
            border-radius: 50%;
            background-color: black;
            width: 20px;
            height: 20px;
            &:after, &:before{
                content: '';
                position: absolute;
                left: 50%;
                top: 50%;
                background-color: white;
                display: block;
                -webkit-transform: rotate(45deg);
                -moz-transform: rotate(45deg);
                -ms-transform: rotate(45deg);
                -o-transform: rotate(45deg);
                transform: rotate(45deg);
            }
            &:after{
                width: 16px;
                height: 2px;
                margin-left: -8px;
                margin-top: -1px;
            }
            &:before{
                width: 2px;
                height: 16px;
                margin-left: -1px;
                margin-top: -8px;
            }
        }
    }

    .modal-body {
        margin: 20px 0;
    }

    .modal-default-button {
        float: right;
    }

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .default,
    .modal-leave-active .default {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
</style>